import { ApiUrls } from '@/service/constants/urls';
import { megacacheTS } from '../Axios';
import { TGoogleRating } from '@/domain/Reviews.domain';

type TMegacacheResponse = TGoogleRating[];

// avail fields: id,google_rating,google_rating_updated_at,google_user_ratings_total,rating;
const FIELDS = 'google_rating,google_user_ratings_total';

export const getGoogleRating = async (
    partnerId: string,
    fields?: string
): Promise<TGoogleRating | undefined> => {
    try {
        const { data } = await megacacheTS.get<TMegacacheResponse>(ApiUrls.partner.root, {
            params: {
                id: partnerId,
                fields: fields || FIELDS,
            },
        });

        if (!data.length) {
            return undefined;
        }
        return data[0];
    } catch (error) {
        return undefined;
    }
};
